'use client';
import { useAuth } from '@clerk/nextjs';
import { useEffect, useState } from 'react';
import { type AccountContextDto } from '@ra-mr/types';

/** Company users remain public visitors; only local internal privileges exclude analytics. */
export const usePublicAnalytics = () => {
  const { isLoaded, userId } = useAuth();
  const [checkedUser, setCheckedUser] = useState<string | null>(null);
  const [internal, setInternal] = useState(true);
  useEffect(() => {
    if (!isLoaded || !userId) { return; }
    const controller = new AbortController();
    const check = async () => {
      try {
        const response = await fetch('/api/account/context', { cache: 'no-store', signal: controller.signal });
        if (!response.ok) { return; }
        const account: AccountContextDto = await response.json();
        if (!controller.signal.aborted) { setInternal(!!account.internalUser); setCheckedUser(userId); }
      } catch { /* Wait for a confirmed local role before enabling analytics. */ }
    };
    void check();
    return () => { controller.abort(); };
  }, [isLoaded, userId]);
  return isLoaded && (!userId || (checkedUser === userId && !internal));
};
